import { useTranslation } from 'react-i18next'

import { Link, Text } from '@reveni-io/reveni-ui'

const OrderRecoveryHint = ({ path }) => {
  const { t } = useTranslation()

  return (
    <>
      {t('¿No recuerdas tu número de pedido?')}{' '}
      <Link href={path}>
        <Text tag="span" type="linkXs">
          {t('Encuéntralo aquí')}
        </Text>
      </Link>
    </>
  )
}

export default OrderRecoveryHint
